import React, { createContext, useEffect } from "react";
import { IEBSSSInjectorContext } from "./types";
import { useDispatch } from "react-redux";
import { injectSessionFromGamify } from "src/base/store/authSlice";
import { getQueryParams } from "src/_utils/urls";
import { toast } from "react-toastify";
import { useEBSSSLayout } from "../EBSSSLayoutContext/useEBSSSLayout";

export const EBSSSInjectorContext = createContext<IEBSSSInjectorContext>({} as IEBSSSInjectorContext);

export const InjectorProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const dispatch = useDispatch();
  const { trans } = useEBSSSLayout();

  console.log("Injector context");

  const injectSession = () => {
    if (window["SESSION_GAMIFY"]) {
      dispatch(injectSessionFromGamify(window["SESSION_GAMIFY"]));
      return;
    }

    let getSessionFromQueryParam = getQueryParams(window.location.href)?.injectable_session ?? "{}";

    if (getSessionFromQueryParam.startsWith("{") && getSessionFromQueryParam.endsWith("}")) {
      getSessionFromQueryParam = JSON.parse(getSessionFromQueryParam);

      if (getSessionFromQueryParam) {
        console.log("getSessionFromQueryParam: ", getSessionFromQueryParam);
        dispatch(injectSessionFromGamify(getSessionFromQueryParam));
        // window.location.href = window.location.origin + window.location.pathname;
      }
    }
  };

  return (
    <EBSSSInjectorContext.Provider
      children={children}
      value={{
        injectSession,
      }}
    />
  );
};
